import type { TransactionStatus } from '@shared/types';

// `@shared/types` is consumed as a type-only workspace in the Vite apps, so
// frontend runtime helpers need a local implementation instead of a value
// import from that package.
export const isTransactionStatusFailedOrReturned = (
  status: TransactionStatus | undefined,
): status is Extract<TransactionStatus, 'failed' | 'returned'> => {
  return status === 'failed' || status === 'returned';
};

// Default status used when a manual-entry / edit form omits a status. The Finix
// webhook path sets status itself; this helper exists for the directInput flow
// (and for edits that clear the status field).
export const inferTransactionStatusFromCompletion = (
  completedTimestamp: Date | undefined,
): Extract<TransactionStatus, 'succeeded' | 'pending'> => {
  return completedTimestamp ? 'succeeded' : 'pending';
};
